import React from 'react';
import { View, Text, Modal } from 'react-native';
import { Button } from 'react-native-elements';
import { AntDesign } from '@expo/vector-icons';
import SuccessModalProps from '../types/components/SuccessModalProps';
import { styles } from '../styles/components/successModal';

export default ({
  isSuccess,
  title,
  message,
  buttonText,
  onConfirm,
  mainColor,
  isMediumScreen,
}: SuccessModalProps): JSX.Element => {
  const renderModal = (): JSX.Element => {
    return (
      <View style={isMediumScreen ? styles.modalContentLarge : styles.modalContentSmall}>
        <View style={[styles.modaIconContainer, { backgroundColor: mainColor }]}>
          <AntDesign
            name={isSuccess ? 'checkcircle' : 'exclamationcircle'}
            color={'#FFFFFF'}
            size={35}
            containerStyle={styles.iconContainer}
          />
        </View>
        <View style={styles.modalTextContainerTitle}>
          <Text style={styles.modalTextTitle}>{title}</Text>
        </View>
        <View style={styles.modalTextContainerMessage}>
          <Text style={styles.modalTextMessage}>{message}</Text>
        </View>
        <View style={styles.modalBtnContainer}>
          <Button
            title={buttonText}
            onPress={() => onConfirm()}
            containerStyle={styles.btnContainerStyle}
            buttonStyle={isMediumScreen ? styles.confirmBtnStyle : styles.confirmBtnStyleSmall}
            titleStyle={[styles.confirmBtnText, { color: mainColor }]}
          />
        </View>
      </View>
    );
  };

  return (
    <Modal visible={true} transparent={true} style={styles.modal}>
      <View style={styles.container}></View>
      <View style={styles.modalBox}>{renderModal()}</View>
    </Modal>
  );
};
